import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { width: "7", height: "18", x: "3", y: "3", rx: "1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { width: "7", height: "7", x: "14", y: "3", rx: "1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { width: "7", height: "7", x: "14", y: "14", rx: "1", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "LayoutPanelLeft";
const LayoutPanelLeft = memo(themed(Icon));
export {
  LayoutPanelLeft
};
//# sourceMappingURL=layout-panel-left.js.map
